import styled from 'styled-components';
import { Text } from '../../../common/Texts';
import { Img } from '../../../common/Image';
import useRedirect from '../../../../hooks/useRedirect';

const NewFiltersCard = () => {
    const { handleRedirection } = useRedirect();

    return (
        <CardWrapper>
            <CardContent>
                <Img
                    src="/assets/professorDashboard/new-filters.png"
                    alt="Library"
                    width={314}
                    height={200}
                />
                <CardRightSide>
                    <RightSideTop>
                        <Text
                            fontWeight="300"
                            color="#fff"
                            fontStyle="italic"
                            lineHeight="1"
                        >
                            Ya podés filtrar y organizar tus cursos a cargo,{' '}
                            <strong style={{ fontStyle: 'normal' }}>
                                encontralos en tu home.
                            </strong>
                        </Text>
                    </RightSideTop>
                    <RightSideBottom>
                        <Text fontWeight="500" fontStyle="italic" color="#fff">
                            Escuchamos tus sugerencias y sumamos nuevos filtros
                            para que ordenes tus cursadas a cargo según el rol
                            del docente: profesor, director o ambos.
                        </Text>
                        <GoToLibraryButton
                            onClick={(e) => {
                                e.preventDefault();
                                const element =
                                    document.getElementById('coursesTeacher');
                                if (element) {
                                    element.scrollIntoView({
                                        behavior: 'smooth',
                                    });
                                }
                            }}
                        >
                            Conocé cómo funciona
                        </GoToLibraryButton>
                    </RightSideBottom>
                </CardRightSide>
            </CardContent>
        </CardWrapper>
    );
};

export default NewFiltersCard;

const CardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const CardContent = styled.div`
    display: flex;
    flex-direction: row;
    background-color: transparent;
    width: 100%;
    border-radius: 0px 30px 30px 0px;
    background-image: url('/assets/professorDashboard/library-card-bg.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    img {
        width: 314px;
        height: auto;
        object-fit: contain;

        @media (max-width: 1400px) {
            width: 240px;
        }

        @media (max-width: 1200px) {
            width: 190px;
        }

        @media (max-width: 992px) {
            display: none;
        }
    }

    @media (max-width: 992px) {
        border-radius: 30px;
    }
`;

const CardRightSide = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0.8rem 1rem;
    width: 100%;
    border-radius: 0px 30px 30px 0px;
    justify-content: center;

    @media (max-width: 768px) {
        border-radius: 0px 0px 30px 30px;
        padding: 1rem;
    }
`;

const RightSideTop = styled.div`
    display: flex;

    p {
        font-size: 42px !important;

        @media (max-width: 1400px) {
            font-size: 28px !important;
        }

        @media (max-width: 1200px) {
            font-size: 24px !important;
        }
    }
    strong {
        font-size: 42px !important;

        @media (max-width: 1400px) {
            font-size: 28px !important;
        }

        @media (max-width: 1200px) {
            font-size: 24px !important;
        }
    }
`;

const RightSideBottom = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 1rem;

    p {
        font-size: 20px !important;

        @media (max-width: 1400px) {
            font-size: 14px !important;
        }

        @media (max-width: 1200px) {
            font-size: 13px !important;
        }

        @media (max-width: 992px) {
            display: none;
        }
    }

    @media (max-width: 768px) {
        align-items: center;
        justify-content: center;
        width: 100%;
    }
`;

const GoToLibraryButton = styled.button`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0.8rem 1.5rem;
    border-radius: 100px;
    background-color: #fff;
    color: #b31d15;
    font-weight: 600;
    font-size: 15px;
    cursor: pointer;
    white-space: nowrap;
    flex-shrink: 0;

    @media (max-width: 1400px) {
        font-size: 13px;
        padding: 0.5rem 1rem;
    }

    @media (max-width: 992px) {
        font-size: 12px;
        padding: 0.4rem 0.8rem;
    }

    @media (max-width: 768px) {
        font-size: 14px;
        padding: 0.6rem 1.2rem;
        align-self: flex-start;
    }
`;
